import React from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';

const Home = ({ location }) => (
  <Redirect to={{ pathname: '/school-newsletters', state: { from: location.pathname } }} />
);

Home.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
};

export default Home;
